import { TextObject } from "@/shared/i18n/translation-types";
import { AccessOptions } from "@/shared/environment/ability.types";
import { useAbilityStore } from "@/shared/store/ability.store";
import { useAbilityRoute } from "@/shared/environment/ability-route";

export interface NavigationEntry {
    index: number;
    icon: string;
    title: TextObject;
    isVisible?: () => boolean;
    path: string;
    alias?: string;
    pathWithoutParam?: string;
    access?: AccessOptions;
    externalLink?: string;
    abilityAlias: string;
    queryParams?: boolean;
    target?: "_blank" | "_self";
    /** Fills the route params of `path` with the ones of the current route (e.g. product, asset), see `useNavItems`. */
    withContextParams?: boolean;
    /**
     * Param names of the target route in path order (an optional param ends with `?`, e.g. `["product?", "asset?"]`).
     * They decide which values of the current context end up in `path` and where.
     */
    routeParams?: string[];
}

export function createNavigationEntries() {
    const result: Array<NavigationEntry> = [];

    const abilityStore = useAbilityStore();
    const { findRouteForAlias } = useAbilityRoute();

    abilityStore.abilities.forEach((ability) => {
        ability.getNavigationMenuEntries?.().forEach((menuEntry) => {
            if (menuEntry.internalRoute) {
                const route = findRouteForAlias(abilityStore.abilities, menuEntry.internalRoute.alias);
                if (route?.isRoot) {
                    const pathWithoutParams = "/" + route.alias;
                    let path = pathWithoutParams;

                    // Leere Parameter hinzufügen
                    route.params.forEach(() => {
                        path += "/-";
                    });

                    result.push({
                        index: result.length,
                        alias: route.alias,
                        icon: menuEntry.icon,
                        path: path,
                        pathWithoutParam: pathWithoutParams,
                        title: menuEntry.title,
                        isVisible: menuEntry.isVisible,
                        ...(route.access ? { access: route.access } : {}),
                        ...(menuEntry.internalRoute.access ? { access: menuEntry.internalRoute.access } : {}),
                        abilityAlias: ability.alias,
                        queryParams: menuEntry.internalRoute.queryParams,
                        withContextParams: menuEntry.internalRoute.withContextParams,
                        routeParams: route.params,
                    });
                }
            } else if (menuEntry.externalRoute) {
                result.push({
                    index: result.length,
                    icon: menuEntry.icon,
                    externalLink: menuEntry.externalRoute.link,
                    path: menuEntry.externalRoute.link,
                    title: menuEntry.title,
                    isVisible: menuEntry.isVisible,
                    ...(menuEntry.externalRoute.access ? { access: menuEntry.externalRoute.access } : {}),
                    abilityAlias: ability.alias,
                    target: "_blank",
                });
            }
        });
    });

    return result;
}
